import React from 'react'

import { Checkbox } from '@mantine/core'

import { use1080pOrLess } from '../../../DefaultPaginatedTableImplementation/use1080pOrLess'

type SelectionColumnCheckboxProps = {
  checked: boolean
  indeterminate: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SelectionColumnCheckbox = ({
  checked,
  indeterminate,
  onChange,
}: SelectionColumnCheckboxProps): React.ReactElement => {
  const is1080pOrLess = use1080pOrLess()
  return (
    <Checkbox
      {...{
        size: is1080pOrLess ? 'xs' : 'sm',
        checked,
        indeterminate,
        onChange,
      }}
    />
  )
}

export default SelectionColumnCheckbox
